import { PORTAL_API_BASE_URL } from '../../../../constants';
import request from '../../../../util/APIUtils';

const BASE = `${PORTAL_API_BASE_URL}/api/person`;
const req = (opts) => request({ ...opts, throw400Error: true });

/** @type {Array<{ serviceId: number, serviceName: string, displayName: string|null }> | null} */
let servicesCatalogCache = null;
/** @type {Promise<Array<{ serviceId: number, serviceName: string, displayName: string|null }>> | null} */
let servicesCatalogPromise = null;

/** @returns {Promise<Array<{ serviceId: number, serviceName: string, displayName: string|null }>>} */
export function listServices() {
  if (servicesCatalogCache) {
    return Promise.resolve(servicesCatalogCache);
  }

  if (!servicesCatalogPromise) {
    servicesCatalogPromise = req({ method: 'GET', url: `${BASE}/services` })
      .then((data) => {
        servicesCatalogCache = Array.isArray(data) ? data : [];
        return servicesCatalogCache;
      })
      .catch((error) => {
        servicesCatalogPromise = null;
        throw error;
      });
  }

  return servicesCatalogPromise;
}

/** @returns {Promise<Array>} */
export function getPersonServices(personId) {
  return req({ method: 'GET', url: `${BASE}/${encodeURIComponent(personId)}/services` });
}

export function updatePersonService(personId, assnId, body) {
  return req({
    body: JSON.stringify(body),
    method: 'PUT',
    url: `${BASE}/${encodeURIComponent(personId)}/services/${encodeURIComponent(assnId)}`,
  });
}

export function createPersonService(personId, body) {
  return req({
    body: JSON.stringify(body),
    method: 'POST',
    url: `${BASE}/${encodeURIComponent(personId)}/services`,
  });
}

export function deletePersonService(personId, assnId) {
  return req({
    method: 'DELETE',
    url: `${BASE}/${encodeURIComponent(personId)}/services/${encodeURIComponent(assnId)}`,
  });
}
